var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateQueryParamsStr } from "../../utils/apiUtils";
const GET_SET_DISCOUNT_CODES = 'api/v2/discountCodes';
const GET_SET_AUTOMATIC_DISCOUNTS = 'api/discounts';
const GET_AVAILABLE_AUTOMATIC_DISCOUNTS = 'api/availableDiscounts';
const GET_DISCOUNT_CODES_CUSTOMER_APP = 'api/v2/washdayapp/discountCodes';
export const getDiscountCodes = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            let queryParams = '';
            // if (params.isActive) {
            //   queryParams += `isActive=${params.isActive}`
            // }
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_SET_DISCOUNT_CODES}/${storeId}?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getStores:', error);
            throw error;
        }
    });
};
export const getAutomaticDiscounts = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const queryParams = generateQueryParamsStr([
                'currentDate',
            ], params);
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_SET_AUTOMATIC_DISCOUNTS}/${storeId}?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getStores:', error);
            throw error;
        }
    });
};
export const getDiscountCodeById = function (storeId, discountId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_SET_DISCOUNT_CODES}/${storeId}/${discountId}`, config);
        }
        catch (error) {
            console.error('Error fetching getDiscountCodeById:', error);
            throw error;
        }
    });
};
export const getAutomaticDiscountById = function (storeId, discountId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_SET_AUTOMATIC_DISCOUNTS}/${storeId}/${discountId}`, config);
        }
        catch (error) {
            console.error('Error fetching getDiscountCodeById:', error);
            throw error;
        }
    });
};
const buildVerifyQueryString = (params) => {
    if (!params)
        return '';
    const entries = [];
    if (params.currentDate)
        entries.push(`currentDate=${encodeURIComponent(params.currentDate)}`);
    if (params.orderSubtotal !== undefined &&
        params.orderSubtotal !== null &&
        Number.isFinite(Number(params.orderSubtotal))) {
        entries.push(`orderSubtotal=${encodeURIComponent(String(params.orderSubtotal))}`);
    }
    return entries.length ? `?${entries.join('&')}` : '';
};
export const verifyDiscountCode = function (storeId, code, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const qs = buildVerifyQueryString(params);
            return yield this.axiosInstance.get(`${GET_SET_DISCOUNT_CODES}/${storeId}/${code}/verify${qs}`, config);
        }
        catch (error) {
            console.error('Error fetching verifyDiscountCode:', error);
            throw error;
        }
    });
};
export const verifyDiscountCodeCustomersApp = function (storeId, code, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const qs = buildVerifyQueryString(params);
            return yield this.axiosInstance.get(`${GET_DISCOUNT_CODES_CUSTOMER_APP}/${storeId}/${code}/verify${qs}`, config);
        }
        catch (error) {
            console.error('Error fetching verifyDiscountCodeCustomersApp:', error);
            throw error;
        }
    });
};
export const getAvailableAutomaticDiscounts = function (storeId, date) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_AVAILABLE_AUTOMATIC_DISCOUNTS}/${storeId}?currentDate=${date}`, config);
        }
        catch (error) {
            console.error('Error fetching getAvailableAutomaticDiscounts:', error);
            throw error;
        }
    });
};
